<div class="from-domains-filter__box">
  <button
    type="button"
    class="from-domains-filter__header"
    [attr.aria-expanded]="!isCollapsed"
    (click)="toggleCollapsed()"
  >
    <i
      class="fas"
      [class.fa-chevron-right]="isCollapsed"
      [class.fa-chevron-down]="!isCollapsed"
    ></i>
    <span class="from-domains-filter__title">From domains options</span>
  </button>

  <div *ngIf="!isCollapsed" class="from-domains-filter__body">
    <div *ngFor="let pair of pairs" class="from-domains-filter__pair">
      <app-switch-checkbox
        bsClass="success"
        [checked]="isChecked(pair.key, false)"
        (change)="onToggle(pair.key, false)"
      >
        {{ pair.negativeLabel }}
      </app-switch-checkbox>
      <app-switch-checkbox
        bsClass="success"
        [checked]="isChecked(pair.key, true)"
        (change)="onToggle(pair.key, true)"
      >
        {{ pair.positiveLabel }}
      </app-switch-checkbox>
    </div>
  </div>
</div>
